import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ReplaySubject } from 'rxjs'
import { map } from 'rxjs/operators'
import { IVideo } from '../../../../shared/models/video.model'
import { NodeItemAnalytics } from '../../../collections/functions/analytics'

export interface VideoListItemComponentProps {
  readonly node: Pick<IVideo, 'id' | 'title' | 'slug_uri' | 'asset' | 'duration' | 'premium'> & {
    publish_start_date: string
  }
  readonly analyticsProps: NodeItemAnalytics
}

@Component({
  selector: 'flo-video-list-item',
  template: `
    <div *ngIf="video$ | async as video">
      <a
        [routerLink]="[]"
        [queryParams]="{ playing: video.id }"
        [queryParamsHandling]="'merge'"
        floAnalytics
        tagName="Link"
        [analyticsProperties]="analytics$ | async"
      >
        <flo-spotlight
          [title]="video?.title"
          [imageUrl]="video.asset.url"
          [duration]="video.duration"
          [publishDate]="video.publish_start_date | isoStringToDate"
          [premium]="video.premium"
          [smallThumbnail]="true"
        ></flo-spotlight>
      </a>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoListItemComponent {
  private readonly props$ = new ReplaySubject<VideoListItemComponentProps>(1)

  @Input()
  set props(props: VideoListItemComponentProps) {
    if (!!props) {
      this.props$.next(props)
    }
  }

  public readonly video$ = this.props$.pipe(map(props => props.node))

  public readonly analytics$ = this.props$.pipe(map(props => props.analyticsProps))
}
